import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api, { errorText, soft } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { downloadFile, queryString } from "@/lib/download";
import useFilters from "@/lib/useFilters";
import { FilterForm } from "@/components/FilterActions";
import Select from "@/components/Select";

// Biblioteca de atribuții: toate atribuțiile din fișele de post, grupate pe structuri (fără duplicate), cu export PDF / Excel / CSV.
export default function DutyLibrary() {
  const { has } = useAuth();
  const f = useFilters({ unit: "", q: "" });
  const [units, setUnits] = useState([]);
  const [data, setData] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });
  const params = { org_unit_id: f.applied.unit, q: f.applied.q };

  useEffect(() => { soft(api.get("/mdm/org-units"), { data: [] }).then(r => setUnits((r.data || []).filter(u => u.active))); }, []);
  useEffect(() => {
    setData(null);
    api.get(`/stat-functii/duties${queryString(params)}`).then(r => setData(r.data)).catch(e => setMsg({ text: errorText(e), type: "error" }));
  }, [f.applied]); // eslint-disable-line react-hooks/exhaustive-deps

  const exportAs = async (ext) => {
    try { await downloadFile(`/stat-functii/duties/export.${ext}${queryString(params)}`, `biblioteca_atributii.${ext}`); }
    catch (e) { setMsg({ text: e.message, type: "error" }); setTimeout(() => setMsg({ text: "" }), 5000); }
  };
  const sorted = [...units].sort((a, b) => (a.level || 0) - (b.level || 0) || (a.name || "").localeCompare(b.name || "", "ro"));
  return (
    <>
      <PageHeader title="Biblioteca de atribuții" subtitle={data ? `${data.total_duties} atribuții în ${data.total_units} structuri` : "Se încarcă..."}
        actions={has("duty_library.view") && <>
          <button className="btn btn-secondary" onClick={() => exportAs("xlsx")} data-testid="lib-xlsx">Export Excel</button>
          <button className="btn btn-secondary" onClick={() => exportAs("csv")} data-testid="lib-csv">Export CSV</button>
          <button className="btn btn-secondary" onClick={() => exportAs("pdf")} data-testid="lib-pdf">Export PDF</button>
        </>} />
      <Toast msg={msg.text} type={msg.type} />
      <FilterForm f={f} testid="lib-filters" style={{ padding: 14, marginBottom: 14 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 10 }}>
          <div><label className="label">Structură</label>
            <Select className="select" value={f.draft.unit} onChange={e => f.set({ unit: e.target.value })} data-testid="lib-unit">
              <option value="">Toate structurile</option>
              {sorted.map(u => <option key={u.id} value={u.id}>{"— ".repeat(Math.max(0, (u.level || 1) - 1))}{u.name}</option>)}
            </Select></div>
          <div><label className="label">Caută în atribuții</label>
            <input className="input" value={f.draft.q} onChange={e => f.set({ q: e.target.value })} data-testid="lib-q" placeholder="ex: salarii" /></div>
        </div>
        {f.draft.unit && <div style={{ fontSize: 12, color: "#64748B", marginTop: 8 }}>Structura aleasă include și subunitățile ei.</div>}
      </FilterForm>
      {data && data.groups.length === 0 && <div className="card" style={{ padding: 24, color: "#64748B" }}>Nicio atribuție. Atribuțiile apar aici după ce sunt completate în fișele de post.</div>}
      {data && data.groups.map(g => (
        <div className="card" key={g.unit_id} style={{ marginBottom: 14 }} data-testid={`lib-group-${g.unit_name}`}>
          <div style={{ padding: "10px 16px", fontWeight: 700, background: "#F8FAFC", borderBottom: "1px solid #E2E8F0" }}>{g.unit_name} <span style={{ color: "#64748B", fontWeight: 500 }}>({g.duties.length})</span></div>
          {g.duties.map((d, i) => (
            <div key={i} style={{ padding: "9px 16px", borderBottom: "1px solid #F1F5F9", display: "flex", gap: 12 }}>
              <div style={{ minWidth: 26, color: "#94A3B8", fontSize: 12, paddingTop: 2 }}>{i + 1}.</div>
              <div style={{ flex: 1, fontSize: 14 }}>
                {d.text}
                <details style={{ marginTop: 2 }}>
                  <summary style={{ fontSize: 11.5, color: "var(--blue-primary)", cursor: "pointer" }}>în {d.count} {d.count === 1 ? "fișă" : "fișe"}</summary>
                  <div style={{ fontSize: 12, color: "#64748B" }}>{d.sources.join(", ")}</div>
                </details>
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
}
